import { Components, Theme, ThemeOptions } from '@mui/material/styles';

const getAccordionTheme = (theme: Theme): ThemeOptions => {
  const accordionTheme: Components<Theme>['MuiAccordion'] = {
    styleOverrides: {
      root: {
        border: 'none',
        boxShadow: 'none',
        '&:before': {
          display: 'none',
        },
        '&.Mui-expanded': {
          margin: 0,
        },
        // Accordion header container styles
        '& .accordion-header': {
          display: 'flex',
          alignItems: 'center',
          gap: theme.unit(2),
          width: '100%',
        },
        // Accordion count tag styles
        '& .accordion-count-tag': {
          height: theme.unit(6),
          fontSize: '12px',
          fontWeight: 500,
          padding: theme.unit(1, 0),
          border: `1px solid ${theme.palette.M3.sys.light['outline 2']}`,
          borderRadius: theme.unit(2),
          margin: theme.unit(0, 2, 0, 0),
        },
        // Accordion content container styles
        '& .accordion-content': {
          display: 'grid',
          gridTemplateColumns: 'repeat(2, 1fr)',
          gap: theme.unit(4),
        },
      },
    },
  };

  const accordionSummaryTheme: Components<Theme>['MuiAccordionSummary'] = {
    styleOverrides: {
      root: {
        justifyContent: 'flex-start',
        minHeight: theme.unit(12),
        padding: theme.unit(0, 0),
        '&.Mui-expanded': {
          minHeight: theme.unit(12),
        },
      },
      content: {
        margin: theme.unit(3, 0),
        flex: '0 1 auto',
        '&.Mui-expanded': {
          margin: theme.unit(3, 0),
        },
      },
    },
  };

  const accordionDetailsTheme: Components<Theme>['MuiAccordionDetails'] = {
    styleOverrides: {
      root: {
        padding: 0,
      },
    },
  };

  return {
    components: {
      MuiAccordion: accordionTheme,
      MuiAccordionSummary: accordionSummaryTheme,
      MuiAccordionDetails: accordionDetailsTheme,
    },
  };
};

export default getAccordionTheme;
